import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";

type NumberTileProps = {
  isDisabled?: boolean;
  isSelected: boolean;
  onPress: () => void;
  page: number;
};

export function NumberTile({ isDisabled, isSelected, onPress, page }: NumberTileProps) {
  return (
    <Button2
      aria-current={isSelected ? "page" : undefined}
      aria-label={`Page ${page}`}
      className={cn(
        "tw:size-8 tw:rounded-lg tw:text-sm tw:font-medium",
        isSelected
          ? "tw:bg-fill-teal-primary tw:text-text-white"
          : "tw:text-text-tertiary tw:hover:bg-fill-quinary",
        isDisabled && "tw:cursor-wait!",
      )}
      isDisabled={isDisabled}
      onPress={onPress}
      variant="blank"
    >
      {page}
    </Button2>
  );
}
